module.exports = __webpack_public_path__ + "img/header-weddingRingsSoleil@2x.cb38e3a.webp";